export const buildUrlWithQuery = (url: string, query: Record<string, unknown>) => {
  const queryString = Object.entries(query)
    .filter(([, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return `${url}?${queryString}`;
};
